module.exports = __webpack_public_path__ + "img/send-offer-button-mobile-fr.58d479aa.jpg";